import clsx from 'clsx'
import React from 'react'
import NeonLogo from '../../icons/NeonLogo'
import useStyles from './NeonLink.styles'
import { NeonLinkProps } from './NeonLinkProps'

const NeonLink: React.FC<NeonLinkProps> = ({ className }) => {
  const classes = useStyles()
  return (
    <a
      href="https://www.neontv.co.nz/"
      className={clsx(classes.neonLink, className)}
    >
      <NeonLogo className={classes.neonLogo} />
    </a>
  )
}

export default NeonLink
